import styled from '@emotion/styled';

export const TitleTextFields = styled.div`
  width: 300px;
  position: absolute;
  top: 15px;
  left: 15px;
  input {
    font-size: 20px;
  }
`;